const users = [
  {
    username: "PrimeKunai",
    description: "A list with the top watched animes all time",
  },
  {
    username: "Zicopele",
    description: "A list 500+ watched that ranges from shounen to romance",
  },
];
export default users;
